export default __webpack_public_path__ + "static/compass_logo-7fc11fe4025363e4bc5b8b9a5e2bd5e3.jpg";